export default "__VITE_ASSET__CDLOJ6CH__"